export default "__VITE_ASSET__CWCCyuIh__"